import React from 'react';
import styled from 'styled-components';
import StrokeIcon from '../../icons/StrokeIcon';
import { darkBlue2, surface } from '../../colors/COLORS';

const Container = styled.span`
  display: flex;
  align-items: center;
`;

interface Props {
  isOpen: boolean,
}

const TaskOperationButton = ({ isOpen }: Props) => (
  <Container>
    <StrokeIcon fill={isOpen ? surface : darkBlue2} />
  </Container>
);

export default TaskOperationButton;
